import Checkmark from '@crehana/icons/outline/Checkmark';
import { clsx } from 'clsx';

interface StepperProps {
  className?: string;
  currentStep?: number;
  steps: string[];
}

const Stepper: React.FC<StepperProps> = ({ className, currentStep, steps }) => (
  <div className={clsx('tw-flex tw-items-center tw-justify-center', className)}>
    {steps.map((step, idx, arr) => {
      const isActive = idx + 1 === currentStep;
      const isCompleted = (currentStep || 0) > idx + 1;

      return (
        <div key={step} className="tw-flex tw-items-center">
          <div
            className={clsx(
              'tw-w-[28px] tw-h-[28px] tw-min-w-[28px] tw-min-h-[28px] tw-flex tw-items-center tw-justify-center tw-border-solid tw-border-[0.1rem] tw-rounded-full',
              isActive || isCompleted
                ? 'tw-text-primary-light-500 tw-bg-primary-light-100 tw-border-primary-light-500'
                : 'tw-text-neutral-light-700 tw-bg-neutral-light-100 tw-border-neutral-light-500',
            )}
          >
            {isCompleted ? (
              <Checkmark className="tw-text-current" size={18} />
            ) : (
              <p className="tw-font-subtitle5">{idx + 1}</p>
            )}
          </div>
          <p
            className={clsx(
              'tw-font-subtitle5 tw-ml-0.8',
              !isActive && 'tw-text-neutral-light-700',
            )}
          >
            {step}
          </p>
          {idx !== arr.length - 1 && (
            <div className="tw-w-3.2 tw-border-solid tw-border-t tw-border-neutral-light-600 tw-mx-1.2" />
          )}
        </div>
      );
    })}
  </div>
);

export default Stepper;
